import { useState } from "react";
import { Plus, Trash2 } from "lucide-react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Input } from "@/components/ui/input";
import { api } from "@/lib/api";
import { useApp } from "@/context/AppContext";
import { Btn } from "@/components/sales/ui";

const F = ({ label, children }) => <label className="block space-y-1.5"><span className="text-xs font-semibold uppercase tracking-wider text-muted-foreground">{label}</span>{children}</label>;

export const AddCompanyDialog = ({ open, onClose, onCreated }) => {
  const { run } = useApp();
  const [f, setF] = useState({ name: "", website: "", industry: "", postcode: "", employees: "" });
  const [nums, setNums] = useState([""]);
  const set = (k) => (e) => setF((s) => ({ ...s, [k]: e.target.value }));
  const submit = async (e) => {
    e.preventDefault();
    let created;
    const ok = await run(async () => {
      const { data } = await api.post("/sales/companies", { ...f, employees: f.employees ? Number(f.employees) : null, phones: nums.filter((n) => n.trim()).map((raw) => ({ raw, label: "main" })) });
      created = data;
    }, "Company added");
    if (ok) onCreated(created);
  };
  return (
    <Dialog open={open} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="sm:max-w-lg" aria-describedby={undefined} data-testid="add-company-dialog">
        <DialogHeader><DialogTitle className="font-display text-2xl">Add company</DialogTitle></DialogHeader>
        <form onSubmit={submit} className="space-y-4">
          <F label="Company name"><Input autoFocus required value={f.name} onChange={set("name")} data-testid="company-name-input" /></F>
          <F label="Phone numbers">
            {nums.map((n, i) => (
              <div key={i} className="flex gap-2">
                <Input value={n} onChange={(e) => setNums(nums.map((x, j) => (j === i ? e.target.value : x)))} placeholder="e.g. 0113 496 0022" data-testid={`company-phone-input-${i}`} />
                {nums.length > 1 && <button type="button" onClick={() => setNums(nums.filter((_, j) => j !== i))} className="px-2 text-muted-foreground"><Trash2 className="h-4 w-4" /></button>}
              </div>
            ))}
            <button type="button" onClick={() => setNums([...nums, ""])} className="text-xs text-muted-foreground hover:text-foreground"><Plus className="inline h-3 w-3" /> Another number</button>
          </F>
          <div className="grid grid-cols-2 gap-3">
            <F label="Website"><Input value={f.website} onChange={set("website")} data-testid="company-website-input" /></F>
            <F label="Industry"><Input value={f.industry} onChange={set("industry")} data-testid="company-industry-input" /></F>
            <F label="Postcode"><Input value={f.postcode} onChange={set("postcode")} /></F>
            <F label="Employees"><Input type="number" min={0} value={f.employees} onChange={set("employees")} /></F>
          </div>
          <div className="flex justify-end gap-2"><Btn type="button" onClick={onClose}>Cancel</Btn><Btn variant="primary" type="submit" data-testid="company-submit-button">Add company</Btn></div>
        </form>
      </DialogContent>
    </Dialog>
  );
};
